import { getEventTracker } from '@libs/eventTracking'
import {
  getCurrentPagePropertyFor,
  getNextPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { WebEventNames } from './common'
import { PageName } from '@app-core/eventTracking/PageName'

interface TrackWebCategoryECPromotionEnterLinkEvent {
  category: string
  toPageUrl: string
  title: string
}

export function trackWebCategoryECPromotionEnterLinkEvent({
  category,
  toPageUrl,
  title,
}: TrackWebCategoryECPromotionEnterLinkEvent) {
  getEventTracker().track({
    name: WebEventNames.WEB_CATEGORY_EC_PROMOTION_ENTER_LINK,
    properties: {
      currentPage: getCurrentPagePropertyFor(PageName.WEB_CATEGORY),
      toPage: getNextPagePropertyFor({
        pageUrl: toPageUrl,
      }),
      title,
      actionTarget: toPageUrl,
      category,
    },
  })
}
